import React from 'react';

import Contact from '../components/contact';
import Careers from '../components/careers';
import DoubleImage from '../components/double-image';
import PageHeader from '../components/page-header';
import Splash from '../components/splash';
import LandingBanner from '../components/landing-banner';
import FeaturedImage from '../components/featured-image';
import FeaturedProjects from '../components/featured-projects';
import ProjectsArchive from '../components/projects-archive';
import JournalArchive from '../components/journal-archive';
import HivemindArchive from '../components/hivemind-archive';
import ImageBlock from '../components/image-block';
import FourItems from '../components/four-items';
import ColumnContent from '../components/column-content';

import Headline from '../components/headline';
import BasicContent from '../components/basic-content';
import FullScreenBasicContent from '../components/full-screen-basic-content';
import BlockQuote from '../components/block-quote';
import BigText from '../components/big-text';
import List from '../components/list';
import LatestJournal from '../components/latest-journal';
import TeamBlock from '../components/team-block';
import TeamValues from '../components/team-values';
import ClientLogos from '../components/client-logos';
import VideoBlock from '../components/video-block';
import Mobiles from '../components/mobiles';
import Mockup from '../components/mockup';
import GalleryBlock from '../components/gallery-block';
import Faqs from '../components/faqs';
import HomeAnimation from '../components/home-animation';
import ServicesIntro from '../components/services-intro';
import Digital from '../components/digital';

const renderBlock = (el, i, type) => {

  if (!el?.fieldGroupName) return null;
  el.key = i

  let block = {
    'Contact': (el) => <Contact {...el} />,
    'CareersForm': (el) => <Careers {...el} />,
    'DoubleImage': (el) => <DoubleImage {...el} />,
    'PageHeader': (el) => <PageHeader {...el} />,
    'LogoBanner': (el) => <Splash {...el} />,
    'LandingBanner': (el) => <LandingBanner {...el} />,
    'FeaturedImage': (el) => <FeaturedImage {...el} />,
    'FeaturedProjects': (el) => <FeaturedProjects {...el} />,
    'ProjectsArchive': (el) => <ProjectsArchive {...el} />,
    'JournalArchive': (el) => <JournalArchive {...el} />,
    'LatestJournal': (el) => <LatestJournal {...el} />,
    'HivemindArchive': (el) => <HivemindArchive {...el} />,
    'ServicesIntro': (el) => <ServicesIntro {...el} />,
    'FourItems': (el) => <FourItems {...el} />,
    'ColumnContent': (el) => <ColumnContent {...el} />,
    'BasicContent': (el) => <BasicContent {...el} />,
    'FullScreenBasicContent': (el) => <FullScreenBasicContent {...el} />,
    'Headline': (el) => <Headline {...el} />,
    'TitleContent': (el) => <BasicContent {...el} />,
    'MobileMockup': (el) => <Mobiles {...el} />,
    'WebMockup': (el) => <Mockup {...el} />,
    'ImageBlock': (el) => <ImageBlock {...el} />,
    'Image': (el) => <ImageBlock {...el} />,
    'Gallery': (el) => <GalleryBlock {...el} />,
    'Video': (el) => <VideoBlock {...el} />,
    'Quote': (el) => <BlockQuote {...el} />,
    'BigText': (el) => <BigText {...el} />,
    'TeamBlock': (el) => <TeamBlock {...el} />,
    'TeamValues': (el) => <TeamValues {...el} />,
    'ClientLogos': (el) => <ClientLogos {...el} />,
    'List': (el) => <List {...el} />,
    'Faqs': (el) => <Faqs {...el} />,
    'HomeAnimation': (el) => <HomeAnimation {...el} />,
    'Digital': (el) => <Digital {...el} />,
  }[el.fieldGroupName.replace(`${type}_Acf_ContentBlocks_`, '')];

  if (!block) return null;

  return block(el);
};

export default renderBlock;